package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_core_quickbooks_di_QuickbooksClientImplModule : Module get() = module {
	single() { _ -> com.essntl.core.quickbooks.data.QuickbooksClientImpl(client=get()) } bind(com.essntl.core.quickbooks.domain.QuickbooksClient::class)
}
public val com.essntl.core.quickbooks.di.QuickbooksClientImplModule.module : org.koin.core.module.Module get() = com_essntl_core_quickbooks_di_QuickbooksClientImplModule
